import Layout from '@/layout'

import asyncDictRoutes from './modules/dict.js'
import asyncOrgRoutes from './modules/org.js'
import asyncUsersRoutes from './modules/user.js'
import asyncAuthRoutes from './modules/auth.js'
import asyncPostRoutes from './modules/post.js'

const asyncSystemRoutes = {
  path: '/base/system',
  component: Layout,
  redirect: 'noRedirect',
  name: '系统管理',
  funcPerms: 'system:setting',
  meta: {
    title: '系统管理',
    icon: 'sysSetting',
    affix: false,
    noCache: true
  },
  children: [asyncOrgRoutes, asyncUsersRoutes, asyncPostRoutes, asyncDictRoutes, asyncAuthRoutes]
}

export default asyncSystemRoutes
